// client/src/layouts/AdminLayout.js
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import AdminTopBar from "../components/AdminTopBar";
import AdminSidebar from "../components/AdminSidebar";

const linkBase =
  "flex items-center gap-3 px-3 py-2 rounded-xl text-sm transition";
const iconDot = "w-2 h-2 rounded-full";

export default function AdminLayout() {
  return (
    <div className="min-h-screen flex bg-gradient-to-br from-[#0f0c29] via-[#302b63] to-[#24243e] text-white">

      {/* ---- SIDEBAR ---- */}
      <AdminSidebar />


      {/* ---- MAIN AREA ---- */}
      <div className="flex-1 flex flex-col">
        <div className="sticky top-0 z-40">
          <AdminTopBar />
        </div>

        <main className="flex-1 overflow-y-auto px-4 sm:px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
